// customers.js — drives the "Everyday Customers" video carousel.
// Step = one card width per click; arrows disable at each end; progress bar
// fills based on how much of the track is visible.

(() => {
  const section = document.querySelector('.customers');
  if (!section) return;

  const track = section.querySelector('.customers__track');
  const cards = track && track.querySelectorAll('.customer-card');
  const prev = section.querySelector('.icon-btn--prev');
  const next = section.querySelector('.icon-btn--next');
  const fill = section.querySelector('.customers__progress-fill');
  if (!track || !cards || cards.length === 0 || !prev || !next) return;

  const step = () => {
    if (cards.length < 2) return cards[0].offsetWidth;
    return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
  };

  const update = () => {
    const max = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;
    prev.disabled = x <= 1;
    next.disabled = x >= max - 1;
    if (fill) {
      const pct = track.scrollWidth > 0
        ? Math.min(100, ((x + track.clientWidth) / track.scrollWidth) * 100)
        : 100;
      fill.style.width = pct + '%';
    }
  };

  prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();

  // Video play/pause — mutually exclusive across cards.
  const stopCard = (card) => {
    const video = card.querySelector('.customer-card__video');
    if (video) {
      video.pause();
      if (!video.ended && video.currentTime > 0) video.currentTime = 0;
    }
    card.classList.remove('is-playing');
  };

  cards.forEach((card) => {
    const play = card.querySelector('.customer-card__play');
    const video = card.querySelector('.customer-card__video');
    const src = card.getAttribute('data-video-src') || '';
    if (!play || !video || !src) return;

    play.addEventListener('click', () => {
      if (card.classList.contains('is-playing')) {
        stopCard(card);
        return;
      }
      cards.forEach((other) => { if (other !== card) stopCard(other); });
      if (!video.getAttribute('src')) video.setAttribute('src', src);
      card.classList.add('is-playing');
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    });

    video.addEventListener('ended', () => stopCard(card));
  });
})();
